import http from "../../http";

const behavior = {
    saveType(r) {
        return  http.confirm.payload("/gateway/api/symanage/pc/BehaviorDataPC/saveType",r )
    },
    selectTypeList(r) {
        return  http.get("/gateway/api/symanage/pc/BehaviorDataPC/selectTypeList",r )
    },
    deleteType(r) {
        return  http.confirm.post("/gateway/api/symanage/pc/BehaviorDataPC/deleteType",r )
    },
    saveLabel(r) {
        return  http.confirm.payload("/gateway/api/symanage/pc/BehaviorDataPC/saveLabel",r )
    },
    selectLabelList(r) {
        return  http.get("/gateway/api/symanage/pc/BehaviorDataPC/selectLabelList",r )
    },
    deleteLabel(r) {
        return  http.confirm.post("/gateway/api/symanage/pc/BehaviorDataPC/deleteLabel",r )
    },
    selectPendingPage(r) {
        return  http.spin.get("/gateway/api/symanage/pc/BehaviorDataPC/selectPendingPage",r )
    },
    saveBehaviorData(r) {
        return  http.confirm.payload("/gateway/api/symanage/pc/BehaviorDataPC/saveBehaviorData",r )
    }
}
export default behavior
